<template>
  <ListView
    :items="properties"
    :selected-item-id="selectedId"
    @select="id => $emit('select', id)"
    @highlight="id => $emit('highlight', id)"
    @unhighlight="id => $emit('unhighlight', id)"
    v-bind="$attrs"
    >
    <template #item="{item}">
      <PropertyItemView
        :property="item"
        show-listing-count
        @edit="() => $emit('edit', item)"
      />
    </template>
  </ListView>
</template>

<script>
import ListView from "@/components/common/ListView.vue";
import PropertyItemView from "@/components/PropertyItemView.vue";
export default {
  components: {PropertyItemView, ListView},
  emits: ['select', 'edit', 'highlight', 'unhighlight'],
  props: {
    properties: Array,
    selectedId: String
  }
}
</script>
